import React from 'react';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { colors } from './styles';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

const AppProvider = () => {
  return (
    <Router>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: colors.secondary,
          },
        }}
      >
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </ConfigProvider>
    </Router>
  );
};

export default AppProvider; 